

export default class DocumentTranslationResponse  {
	LangCode?: string = '';
	Text?: string = '';
	constructor(obj?: Partial<DocumentTranslationResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
